import isMobile from 'ismobilejs';
import { getBridgeToNative } from '../window-utils';
import { isAlfaMobileWebviewByUserAgent } from './extract-alfa-mobile-webview-params/is-alfa-mobile-webview';
export const getPlatformType = () => {
    const userAgent = window?.navigator?.userAgent ?? '';
    const appVer = getBridgeToNative()?.appVersion;
    const isWebView = isAlfaMobileWebviewByUserAgent(userAgent, appVer);
    const platformType = isMobile(userAgent).any || isWebView ? 'mobile' : 'desktop';
    return platformType;
};
